import { useQuery } from '@tanstack/react-query'

import { components } from '~/clients/optimus-api-types.generated'
import api from '~/clients/optimus-client'
import { handleApiRequest } from '~/hooks/tanstack-query/optimus/shared/apiWrapper'

export const useApplyRecurringAssignmentsQuery = (data: Omit<components['schemas']['RecurringAssignmentApplyRequest'], 'preview'>) =>
    useQuery({
        queryKey: ['previewRecurringAssignments', data],
        queryFn: async () => handleApiRequest(() => api.recurringAssignments.apply({ ...data, preview: true })),
    })
